import { useEffect, useState } from "react";
import { ArrowClockwise, ArrowSquareOut } from "@phosphor-icons/react";

const LOGIN_IFRAME_URL = "https://awadhcrypto.in/exchange/pega-pay/login";

export default function LoginPage() {
  const [loading, setLoading] = useState(true);
  const [slowLoad, setSlowLoad] = useState(false);

  useEffect(() => {
    document.title = "Login — Rupora";
    window.scrollTo(0, 0);
    const t = setTimeout(() => setSlowLoad(true), 15000);
    return () => {
      document.title = "Rupora — USDT to INR Exchange";
      clearTimeout(t);
    };
  }, []);

  return (
    <div className="fixed inset-0 bg-night" data-testid="login-page">
      <div className="relative h-full w-full">
        {loading && (
          <div className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-4 bg-night" data-testid="login-loading">
            <div className="h-9 w-9 animate-spin rounded-full border-2 border-line border-t-brand-500" />
            <p className="text-sm text-mist">Loading secure login…</p>
          </div>
        )}
        <iframe
          src={LOGIN_IFRAME_URL}
          title="Rupora Login"
          data-testid="login-iframe"
          onLoad={() => setLoading(false)}
          className="h-full w-full border-0"
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-downloads"
          allow="clipboard-write"
        />
        {slowLoad && loading && (
          <div className="absolute inset-x-4 bottom-6 z-20 mx-auto max-w-sm rounded-2xl border border-line bg-pine p-4 text-center" data-testid="login-slow-warning">
            <p className="text-sm text-mist">Taking longer than usual. Check your connection.</p>
            <div className="mt-3 flex justify-center gap-3">
              <button
                onClick={() => window.location.reload()}
                data-testid="login-retry-button"
                className="inline-flex items-center gap-2 rounded-full bg-brand-600 px-5 py-2 text-sm font-semibold text-white"
              >
                <ArrowClockwise size={14} weight="bold" /> Retry
              </button>
              <a
                href={LOGIN_IFRAME_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="login-open-external"
                className="inline-flex items-center gap-2 rounded-full border border-line px-5 py-2 text-sm font-semibold text-paper/80"
              >
                <ArrowSquareOut size={14} weight="bold" /> Open in new tab
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
